module.exports = "/lucky-balls/img/weager/balls/color/yellow.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/balls/color/yellow.png
// module id = 1183
// module chunks = 0